import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Section, EyebrowHeading } from "../Section";
import type { Audience } from "@/content/audiences";

export function AudienceProofRow({ audience: a }: { audience: Audience }) {
  return (
    <Section className="pt-0">
      <EyebrowHeading
        eyebrow="Bevis"
        title="Så ser det ut i praktiken."
        lede="Två exempel från kunder med liknande utgångspunkt som er."
      />
      <div className="mt-12 grid gap-5 md:grid-cols-2">
        {a.proof.map((p) => (
          <Link
            key={p.videoId}
            to="/case"
            className="group flex flex-col overflow-hidden rounded-3xl border border-white/10 bg-surface transition-colors hover:border-mint/40"
          >
            <div className="relative aspect-video overflow-hidden bg-black">
              <img
                src={`https://i.ytimg.com/vi/${p.videoId}/hqdefault.jpg`}
                width={480}
                height={360}
                alt={p.client}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
              <div className="absolute left-4 top-4 rounded-full bg-black/60 px-3 py-1 text-[11px] uppercase tracking-widest text-white/90 backdrop-blur">
                {p.tag}
              </div>
            </div>
            <div className="flex flex-1 flex-col p-6">
              <div className="text-xs uppercase tracking-widest text-muted-foreground">
                {p.client}
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground/85">
                {p.impact}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-mint">
                Se caset <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </Section>
  );
}
